<template>
  <div >
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="100px" size="mini">
        <div class="formItemBox " v-if="usertype==2">
            <el-form-item label="业务期间:" >
              <el-date-picker
              v-model="searchFrom.yuefen"
              type="monthrange" format="yyyy-MM" value-format="yyyy-MM"
              range-separator="至"
              start-placeholder="开始月份"
              end-placeholder="结束月份">
            </el-date-picker>
            </el-form-item>
            <el-form-item label="业务部门:" >
              <el-select  v-model="searchFrom.departmentCode" filterable placeholder="请选择" >
                <el-option  label="全部" value="" ></el-option>
                <el-option v-for="item in bumenList" :label="item.name" :value="item.code" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
        </div>
        <div class="searchBtnBox">
          <el-form-item btnCode="009M0I0100" v-if="usertype==2&&btnFlg[0]">
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item btnCode="009M0I0200" v-if="usertype==2">
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
          <el-form-item btnCode="009M0I0200" v-if="usertype!=2&&btnFlg[1]">
            <el-button type="primary" @click="scyhzFn">生成月汇总</el-button>
          </el-form-item>
          <el-form-item btnCode="009M0I0200" v-if="usertype!=2&&btnFlg[2]">
            <el-button type="primary" @click="delFN">删除</el-button>
          </el-form-item>
          <el-form-item>
            <p class="margin0">应收金额合计:<span class="red">{{map.amountReceivable}}</span>元</p>
          </el-form-item>
          <el-form-item>
            <p class="margin0">不含税金额合计:<span class="red">{{map.priceExcludTax}}</span>元</p>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!-- 表格 -->
    <div :style="{height:h}">
      <el-table :data="tableList" ref="table" v-loading="loading" @row-click="handleRowClick"  highlight-current-row  bordersize="mini" class="tableComent" height="100%" style="width: 100%" center border >
        <el-table-column fixed type="index"  width="55" label="序号"></el-table-column>
        <el-table-column label="操作"  width="200">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="mini" v-if="usertype!=2&&scope.row.auditStatus==1&&userCode==scope.row.auditUserId&&btnFlg[3]" @click="shenheFN(scope.row)">审核</el-button>
              <el-button type="text" size="mini" v-if="usertype!=2&&scope.row.auditStatus>1&&btnFlg[8]" @click="CXshenheFN(scope.row)">撤销审核</el-button>
              <el-button type="text" size="mini" v-if="scope.row.auditStatus==1&&usertype!=2&&btnFlg[4]" @click="gengxianFn(scope.row)">更新</el-button>
              <el-button type="text" size="mini" v-if="(scope.row.auditStatus=='0'||scope.row.auditStatus=='2')&&btnFlg[5]" @click="pingzhengFN(scope.row)">凭证</el-button>
              <el-button type="text" size="mini" v-if="btnFlg[6]&&(scope.row.auditStatus=='0'||scope.row.auditStatus=='2')" @click="exportFn(scope.row)" :disabled="isDisable">导出</el-button>
              <!-- <el-button type="text" size="mini" @click="lookImage(scope.row)">打印</el-button> -->
              <el-button type="text" size="mini" @click="shjlFN(scope.row)"  v-if="usertype==2&&btnFlg[7]">审核记录</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createSubdepartmentName" min-width="200" v-if="usertype==2" label="业务部门"></el-table-column>
        <el-table-column prop="businessDate" width="120" :formatter="emptyFn" label="业务期间">
          <template scope="scope">
            <el-button type="text" size="mini" @click="lookFN(scope.row)">{{scope.row.businessDate}}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="businessDate" width="120" :formatter="emptyFn" label="审核状态" v-if="usertype!=2">
          <template scope="scope">
            <div>
              <el-button type="text" size="mini" @click="shjlFN(scope.row)" v-if="scope.row.auditStatus==2||scope.row.auditStatus==3">{{['不审核','待审核','审核通过','审核驳回'][scope.row.auditStatus]}}</el-button>
              <span v-else>{{['不审核','待审核','审核通过','审核驳回'][scope.row.auditStatus]}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="liquidatedAmount" min-width="130" :formatter="emptyFn" label="结算量" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="amountReceivable" min-width="130" :formatter="emptyFn" label="应收金额(元)"></el-table-column>
        <el-table-column prop="priceExcludTax" min-width="130" :formatter="emptyFn" label="不含税金额(元)"></el-table-column>
        <el-table-column prop="auditUserName"  label="审核人" width="170"></el-table-column>
        <el-table-column prop="createUser"  label="创建人" width="170"></el-table-column>
        <el-table-column prop="createTime" :formatter="dateTimeFormat" label="创建时间" width="170"></el-table-column>

      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 生成月汇总 -->
    <el-dialog  title="生成月汇总"  :close-on-click-modal="false" :close-on-press-escape="false" class="jiaoyan" @close="SCdialog=false"   :visible.sync="SCdialog" width="550px" center>
      <span>
         <el-form :inline="true" :rules="rules" :model="addFrom" ref="addFrom" class="demo-form-inline" label-width="130px" size="mini">
        <div >
             <el-form-item label="请选择月份:" prop="businessDate" >
                <el-date-picker  v-model="addFrom.businessDate" format="yyyy-MM" value-format="yyyy-MM" type="month"
                placeholder="选择月"  :picker-options="pickerOptions"> </el-date-picker>
              </el-form-item>
              <el-form-item label="部门名称:" prop="subdepartmentCode" >
                <el-select  v-model="addFrom.subdepartmentCode" filterable placeholder="请选择" @change="bumenChange" style="width: 230px;">
                  <el-option v-for="item in bumenList" :label="item.name" :value="item.code" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="SCdialog = false">取 消</el-button>
        <el-button type="primary" @click="saveFn">保存</el-button>
      </span>
    </el-dialog>
    <!-- 审核 -->
    <el-dialog  title="审核" :close-on-click-modal="false" :close-on-press-escape="false"  @close="SHflag = false"  :visible.sync="SHflag" width="400px" center>
      <div>
        <el-form  :inline="true" :rules="rules"  ref="SHform" :model="SHform"  class="demo-form-inline jiaoyan"  label-width="100px"  size="mini"  >
          <el-form-item prop="result" label="审核结果:">
            <template>
              <el-radio v-model="SHform.result" label="1">通过</el-radio>
              <el-radio v-model="SHform.result" label="2">驳回</el-radio>
            </template>
          </el-form-item>
          <el-form-item label="审核备注:" class="item1" prop="auditRemark"  :rules="SHform.result==2?rules.auditRemark :[{required: false}]" >
            <el-input placeholder="" type="textarea" maxlength="100" v-model.trim="SHform.auditRemark " class="gjh"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="SHflag = false">取 消</el-button>
        <el-button type="primary" @click="SHsaveFn()">确 定</el-button>
      </span>
    </el-dialog>
   <!-- 凭证 -->
   <pingzheng v-if="pzFlag"  :rowData="row" :pzFlag.sync='pzFlag'></pingzheng>
   <!-- 审核记录 -->
  <shenhejilu v-if="shjlFlag"  :rowData="row" :shjlFlag.sync='shjlFlag'></shenhejilu>
  </div>
</template>
<script>
import { getBtn } from '@/utils/getButton'
import { findMonthSummaryList, saveSummary, findMonthSummaryTotal, deleteSummary, updateSummary, auditSummary, revokeAuditSummary } from '@/api/newTMS'
import { getCurrUserDepartment } from '@/api/newCrm'
import { emptyFn, dateTimeFormat } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import pingzheng from './pingzheng'
import shenhejilu from './shenhejilu'
export default {
  props: ['invoiceMark', 'usertype'],
  components: {
    pingzheng, shenhejilu
  },
  data () {
    return {
      dateTimeFormat: dateTimeFormat,
      isDisable: false,
      emptyFn: emptyFn,
      h: 500,
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      tableList: [],
      total: 0,
      map: {},
      loading: false,
      bumenList: [],
      addFrom: {},
      SCdialog: false,
      rules: {
        businessDate: [
          { required: true, message: '请选择月份', trigger: ['blur', 'change'] }
        ],
        result: [
          { required: true, message: '请选择审核结果', trigger: ['blur', 'change'] }
        ],
        auditRemark: [
          { required: true, message: '请收入审核备注', trigger: ['blur', 'change'] }
        ],
        subdepartmentCode: [
          { required: true, message: '请选择部门', trigger: ['blur', 'change'] }
        ]
      },
      row: {},
      SHflag: false,
      SHform: {},
      pickerOptions: { disabledDate (time) {
        // 获取当前日期
        const currentDate = new Date()
        // 设置为当月第一天
        currentDate.setDate(1)
        // 清除时间部分
        currentDate.setHours(0, 0, 0, 0)
        // 比较月份和年份
        const targetMonth = new Date(time)
        targetMonth.setDate(1)
        targetMonth.setHours(0, 0, 0, 0)
        // 如果目标月份大于当前月份，则禁用
        return targetMonth > currentDate
      } },
      pzFlag: false,
      shjlFlag: false,
      userCode: localStorage.getItem('userCode'),
      btnFlg: [],
      btnIdArr: []
    }
  },
  created () {
    if (this.invoiceMark == 1) {
      this.btnIdArr = ['01N01F0100', '01N01F0200', '01N01F0300', '01N01F0400', '01N01F0500', '01N01F0600', '01N01F0700', '01N01F0800', '01N01F0B00']
      this.btnFlg = getBtn(this.btnIdArr, '/yikaipiaoSR')
    } else if (this.invoiceMark == 2) {
      this.btnIdArr = ['01N01G0100', '01N01G0200', '01N01G0300', '01N01G0400', '01N01G0500', '01N01G0600', '01N01G0700', '01N01G0800', '01N01G0B00']
      this.btnFlg = getBtn(this.btnIdArr, '/weikaipiaoSR')
    }

    getCurrUserDepartment().then(res => { this.bumenList = res })
    if (this.usertype == 2) {
      this.$set(this.searchFrom, 'yuefen', this.getriqi())
    }

    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 200) + 'px'
  },
  methods: {
    // 选择部门
    bumenChange (e) {
      let json1 = this.bumenList.filter(item => item.code == e)
      this.$set(this.addFrom, 'subdepartmentName', json1[0].name)
    },
    // 撤销审核
    CXshenheFN (row) {
      this.$confirm('是否执行撤销审核操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        revokeAuditSummary({ id: this.row.id }).then(res => {
          this.getList()
          this.$message({
            message: '操作成功',
            type: 'success'
          })
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
            }
          })
        })
      }).catch(() => {

      })
    },
    // 业务期间跳转
    lookFN (row) {
      this.$emit('tiaozhuan', { businessDate: row.businessDate, createSubdepartmentCode: row.createSubdepartmentCode })
    },
    getriqi () {
      const months = []
      const date = new Date()
      for (let i = 0; i < 3; i++) {
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        months.push(`${year}-${month}`)
        date.setMonth(date.getMonth() - 1)
      }

      return [months[2], months[0]] // 返回数组，如 ["2025-04", "2025-06"]
    },
    // 审核记录
    shjlFN (row) {
      this.row = row
      this.shjlFlag = true
    },
    // 凭证
    pingzhengFN (row) {
      this.row = row
      this.pzFlag = true
    },
    // 审核
    shenheFN (row) {
      this.SHform = {}
      this.SHflag = true
      this.SHform.id = row.id
    },
    SHsaveFn () {
      this.$refs.SHform.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          auditSummary(this.SHform).then(res => {
            loading.close()
            this.SHflag = false
            this.getList()
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 更新
    gengxianFn (row) {
      this.$confirm('是否执行更新操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        updateSummary({ id: this.row.id }).then(res => {
          this.getList()
          this.$message({
            message: '操作成功',
            type: 'success'
          })
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
            }
          })
        })
      }).catch(() => {

      })
    },
    // 生成月汇总
    scyhzFn () {
      this.SCdialog = true
    },
    saveFn () {
      this.$refs.addFrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          this.addFrom.ieMark = 1// 收支标记 1：收入 2：成本
          this.addFrom.invoiceMark = this.invoiceMark// 1：已开票与无票收入/已开票成本 2：未开票收入/未开票成本
          saveSummary(this.addFrom).then(res => {
            loading.close()
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.SCdialog = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        } else {
          return false
        }
      })
    },
    // 删除
    delFN () {
      if (!this.row.id) {
        this.$alert('请选择要删除的数据!', '系统提示')
        return
      }
      this.$confirm('是否执行删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteSummary({ id: this.row.id }).then(res => {
          this.getList(this.searchFrom)
          this.$message({
            message: '操作成功',
            type: 'success'
          })
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
            }
          })
        })
      }).catch(() => {

      })
    },
    // 导出
    exportFn (row) {
      exportExcel(
        this.global.tmsPlus + '/customerMonthly/openCompleteTicketExportByTempExcel',
        { id: row.id },
        '月收入汇总'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.row = row
      this.$refs.table.toggleRowSelection(row)
    },
    searchFn () {
      this.getList()
    },
    // 获取货物列表
    getList () {
      this.searchFrom.ieMark = 1// 收支标记 1：收入 2：成本
      this.searchFrom.invoiceMark = this.invoiceMark// 1：已开票与无票收入/已开票成本 2：未开票收入/未开票成本
      this.searchFrom.flag = this.usertype// 角色标记：1.业务、审批人 2.财务
      if (this.searchFrom.yuefen) {
        this.searchFrom.businessDateStart = this.searchFrom.yuefen[0]
        this.searchFrom.businessDateEnd = this.searchFrom.yuefen[1]
      } else {
        this.searchFrom.businessDateStart = null
        this.searchFrom.businessDateEnd = null
      }
      this.loading = true
      findMonthSummaryList(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      }).catch(error => {
        this.$message.error(error.message)
      })
      findMonthSummaryTotal(this.searchFrom).then(res => {
        this.map = res
      }).catch(error => {
        this.$message.error(error.message)
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList()
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList()
    },
    // 重置
    resetForm (formName) {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
      this.$set(this.searchFrom, 'yuefen', this.getriqi())
    }

  }
}
</script>
<style scoped lang='less'>
/deep/.el-form{
  width: 100%;
}
/deep/.searchBox .el-input--mini .el-input__inner{
  width: 150px !important;
}

</style>
